let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("7zMjZ"), load("a1dBM"), load("68Kzv"), load("3NvtU"), load("fS7Ii")]).then(() => parcelRequire('5mAw8'));